import React from 'react';
import { XCircle } from 'lucide-react';
export function FailedSolutions() {
  const solutions = [{
    title: '💊 Los analgésicos: la trampa del volumen',
    desc: 'Bajar el volumen del dolor no quita la presión mecánica. El nervio sigue aplastado. La señal sigue ahí. Solo que ahora no la escuchas. Hasta que la medicación se acaba y el dolor vuelve — frecuentemente más fuerte.'
  }, {
    title: '🧘 Los estiramientos de YouTube: el error más peligroso',
    desc: 'El 70% de los estiramientos recomendados para ciática en internet aumentan la presión intradiscal. Sentarte en la cama y tocar la punta de los pies, llevar la rodilla al pecho con fuerza, doblar el torso hacia adelante… Todos esos movimientos, hechos en el momento equivocado, son gasolina pura sobre el nervio inflamado.'
  }, {
    title: '🛌 El reposo absoluto: lento y silencioso',
    desc: 'Quedarte quieto funciona por unas horas. Pero después de 48–72 horas, los músculos que deberían proteger tu columna empiezan a debilitarse. Las articulaciones se vuelven rígidas. Y cuando intentas moverte de nuevo, el sistema está más frágil que antes.'
  }, {
    title: '🧴 Las pomadas y masajes en la pierna',
    desc: 'El dolor que sientes en el glúteo o en la pierna no es el problema — es el mensajero. El fuego está en la zona lumbar / pelvis. Masajear el tobillo para apagar ese fuego es como intentar enfriar el motor de un auto calentando el limpiaparabrisas.'
  }];
  return <section className="bg-white text-slate-800 py-20 px-4 border-t border-slate-200" data-id="element-34">
      <div className="max-w-4xl mx-auto" data-id="element-35">
        <div className="text-center mb-16" data-id="element-36">
          <h2 className="text-3xl md:text-5xl font-extrabold text-slate-900 mb-6" data-id="element-37">
            Por qué lo que probaste no funcionó
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-38">
            No es que seas difícil de tratar. Es que las soluciones que te
            dieron fueron diseñadas para otro problema.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-39">
          {solutions.map((sol, idx) => <div key={idx} className="bg-slate-50 p-8 rounded-2xl border border-slate-200 relative overflow-hidden group hover:border-red-200 transition-colors" data-id="element-40">
              <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-41">
                <XCircle className="w-24 h-24 text-red-500" data-id="element-42" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-4 relative z-10" data-id="element-43">
                {sol.title}
              </h3>
              <p className="text-slate-600 leading-relaxed relative z-10" data-id="element-44">
                {sol.desc}
              </p>
            </div>)}
        </div>

        <div className="bg-slate-900 text-white p-8 md:p-10 rounded-2xl text-center shadow-xl" data-id="element-45">
          <p className="text-2xl md:text-3xl font-extrabold text-orange-400" data-id="element-46">
            Ninguna de estas cosas funciona porque ninguna aborda el momento
            crítico: los 7 minutos después de despertar.
          </p>
        </div>
      </div>
    </section>;
}